import React from "react";
import { aiPrompt } from "./firebase";

// ---- DATA ----
export var SHIFT_COLORS = ["#2563eb", "#1e40af", "#059669", "#047857", "#7c3aed", "#c2410c", "#0891b2", "#4f46e5", "#b91c1c", "#ca8a04"];
export var QUALIFICATIONS_LIST = ["ABEM Board Certified", "AOBEM Board Certified", "Pediatric EM Fellowship", "Toxicology Fellowship", "Critical Care Fellowship"];
export var HOSPITALS_DATA = [
  {
    id: 1, name: "Desert Valley Hospital", short: "Desert Valley", location: "Victorville, CA", status: "active",
    credentialTypes: ["State Medical License", "DEA Registration", "ACLS Certification", "PALS Certification"],
    shifts: [
      {
        id: 1, name: "MD Day", role: "MD", start: "06:00", end: "18:00", color: "#2563eb",
        credentialReqs: [{ type: "State Medical License", exemptIf: null }, { type: "DEA Registration", exemptIf: null }, { type: "ACLS Certification", exemptIf: ["ABEM Board Certified", "AOBEM Board Certified"] }]
      },
      {
        id: 2, name: "MD Night", role: "MD", start: "18:00", end: "06:00", color: "#1e40af",
        credentialReqs: [{ type: "State Medical License", exemptIf: null }, { type: "DEA Registration", exemptIf: null }, { type: "ACLS Certification", exemptIf: ["ABEM Board Certified", "AOBEM Board Certified"] }]
      },
      {
        id: 3, name: "ML Day", role: "Midlevel", start: "06:00", end: "18:00", color: "#059669",
        credentialReqs: [{ type: "State Medical License", exemptIf: null }, { type: "ACLS Certification", exemptIf: null }]
      },
      {
        id: 4, name: "ML Night", role: "Midlevel", start: "18:00", end: "06:00", color: "#047857",
        credentialReqs: [{ type: "State Medical License", exemptIf: null }, { type: "ACLS Certification", exemptIf: null }]
      },
      {
        id: 5, name: "Swing Shift", role: "MD/Midlevel", start: "13:00", end: "01:00", color: "#7c3aed",
        credentialReqs: [{ type: "State Medical License", exemptIf: null }, { type: "ACLS Certification", exemptIf: ["ABEM Board Certified", "AOBEM Board Certified"] }]
      },
    ],
    staffingRules: [
      { shift: "MD Day", minimum: 1, required: true }, { shift: "MD Night", minimum: 1, required: true },
      { shift: "ML Day", minimum: 0, required: false }, { shift: "ML Night", minimum: 0, required: false }, { shift: "Swing Shift", minimum: 0, required: false },
    ],
  },
  {
    id: 2, name: "Chino Valley Medical Center", short: "Chino Valley", location: "Chino, CA", status: "active",
    credentialTypes: ["State Medical License", "DEA Registration", "Board Certification", "ACLS Certification"],
    shifts: [
      {
        id: 6, name: "MD Day", role: "MD", start: "06:00", end: "18:00", color: "#2563eb",
        credentialReqs: [{ type: "State Medical License", exemptIf: null }, { type: "DEA Registration", exemptIf: null }, { type: "ACLS Certification", exemptIf: ["ABEM Board Certified", "AOBEM Board Certified"] }]
      },
      {
        id: 7, name: "MD Mid", role: "MD", start: "10:00", end: "22:00", color: "#3b82f6",
        credentialReqs: [{ type: "State Medical License", exemptIf: null }, { type: "DEA Registration", exemptIf: null }]
      },
      {
        id: 8, name: "MD Night", role: "MD", start: "18:00", end: "06:00", color: "#1e40af",
        credentialReqs: [{ type: "State Medical License", exemptIf: null }, { type: "DEA Registration", exemptIf: null }, { type: "ACLS Certification", exemptIf: ["ABEM Board Certified", "AOBEM Board Certified"] }]
      },
      {
        id: 9, name: "ML Day", role: "Midlevel", start: "06:00", end: "18:00", color: "#059669",
        credentialReqs: [{ type: "State Medical License", exemptIf: null }, { type: "ACLS Certification", exemptIf: null }]
      },
      {
        id: 10, name: "ML Night", role: "Midlevel", start: "18:00", end: "06:00", color: "#047857",
        credentialReqs: [{ type: "State Medical License", exemptIf: null }, { type: "ACLS Certification", exemptIf: null }]
      },
    ],
    staffingRules: [
      { shift: "MD Day", minimum: 1, required: true }, { shift: "MD Mid", minimum: 0, required: false }, { shift: "MD Night", minimum: 1, required: true },
      { shift: "ML Day", minimum: 0, required: false }, { shift: "ML Night", minimum: 0, required: false },
    ],
  },
  {
    id: 3, name: "Montclair Hospital Medical Center", short: "Montclair", location: "Montclair, CA", status: "active",
    credentialTypes: ["State Medical License", "DEA Registration"],
    shifts: [
      {
        id: 11, name: "MD Day", role: "MD", start: "06:00", end: "18:00", color: "#2563eb",
        credentialReqs: [{ type: "State Medical License", exemptIf: null }, { type: "DEA Registration", exemptIf: null }]
      },
      {
        id: 12, name: "MD Night", role: "MD", start: "18:00", end: "06:00", color: "#1e40af",
        credentialReqs: [{ type: "State Medical License", exemptIf: null }, { type: "DEA Registration", exemptIf: null }]
      },
      {
        id: 13, name: "ML Mid", role: "Midlevel", start: "10:00", end: "22:00", color: "#059669",
        credentialReqs: [{ type: "State Medical License", exemptIf: null }]
      },
    ],
    staffingRules: [
      { shift: "MD Day", minimum: 1, required: true }, { shift: "MD Night", minimum: 1, required: true }, { shift: "ML Mid", minimum: 0, required: false },
    ],
  },
];

export var PROVIDERS_INIT = [
  {
    id: 1, name: "Dr. Sarah Chen", role: "Physician", phone: "(555) 101-0001", email: "s.chen@email.com", status: "active", sites: [1, 2], targetShifts: 14, employmentType: "full_time", maxConsecutive: 0, qualifications: ["ABEM Board Certified"],
    credentials: [
      { site: "Desert Valley", siteId: 1, type: "State Medical License", expires: "2026-08-15", status: "current", licenseNum: "A12345" },
      { site: "Desert Valley", siteId: 1, type: "DEA Registration", expires: "2027-01-10", status: "current", licenseNum: "DEA-SC001" },
      { site: "Chino Valley", siteId: 2, type: "State Medical License", expires: "2026-06-01", status: "current", licenseNum: "A12345" },
      { site: "Chino Valley", siteId: 2, type: "DEA Registration", expires: "2027-01-10", status: "current", licenseNum: "DEA-SC001" },
    ]
  },
  {
    id: 2, name: "Dr. Marcus Rivera", role: "Physician", phone: "(555) 101-0002", email: "m.rivera@email.com", status: "active", sites: [1, 3], targetShifts: 14, employmentType: "full_time", maxConsecutive: 0, qualifications: [],
    credentials: [
      { site: "Desert Valley", siteId: 1, type: "State Medical License", expires: "2026-11-30", status: "current", licenseNum: "B22334" },
      { site: "Desert Valley", siteId: 1, type: "DEA Registration", expires: "2026-10-15", status: "current", licenseNum: "DEA-MR002" },
      { site: "Desert Valley", siteId: 1, type: "ACLS Certification", expires: "2026-09-01", status: "current", licenseNum: "ACLS-MR" },
      { site: "Montclair", siteId: 3, type: "State Medical License", expires: "2026-03-15", status: "expiring", licenseNum: "B22334" },
      { site: "Montclair", siteId: 3, type: "DEA Registration", expires: "2026-10-15", status: "current", licenseNum: "DEA-MR002" },
    ]
  },
  {
    id: 3, name: "Dr. James Whitfield", role: "Physician", phone: "(555) 101-0003", email: "j.whitfield@email.com", status: "active", sites: [2], targetShifts: 12, employmentType: "full_time", maxConsecutive: 0, qualifications: ["ABEM Board Certified"],
    credentials: [
      { site: "Chino Valley", siteId: 2, type: "State Medical License", expires: "2027-01-20", status: "current", licenseNum: "C33456" },
      { site: "Chino Valley", siteId: 2, type: "DEA Registration", expires: "2027-02-15", status: "current", licenseNum: "DEA-JW003" },
    ]
  },
  {
    id: 4, name: "Dr. Anika Patel", role: "Physician", phone: "(555) 101-0004", email: "a.patel@email.com", status: "active", sites: [1, 2, 3], targetShifts: 16, employmentType: "full_time", maxConsecutive: 0, qualifications: ["ABEM Board Certified"],
    credentials: [
      { site: "Desert Valley", siteId: 1, type: "State Medical License", expires: "2026-09-01", status: "current", licenseNum: "D44567" },
      { site: "Desert Valley", siteId: 1, type: "DEA Registration", expires: "2027-03-01", status: "current", licenseNum: "DEA-AP004" },
      { site: "Chino Valley", siteId: 2, type: "State Medical License", expires: "2026-09-01", status: "current", licenseNum: "D44567" },
      { site: "Chino Valley", siteId: 2, type: "DEA Registration", expires: "2027-03-01", status: "current", licenseNum: "DEA-AP004" },
      { site: "Montclair", siteId: 3, type: "State Medical License", expires: "2026-09-01", status: "current", licenseNum: "D44567" },
      { site: "Montclair", siteId: 3, type: "DEA Registration", expires: "2027-03-01", status: "current", licenseNum: "DEA-AP004" },
    ]
  },
  {
    id: 5, name: "Dr. Robert Kim", role: "Physician", phone: "(555) 101-0005", email: "r.kim@email.com", status: "active", sites: [3], targetShifts: 10, employmentType: "full_time", maxConsecutive: 0, qualifications: [],
    credentials: [
      { site: "Montclair", siteId: 3, type: "State Medical License", expires: "2026-12-01", status: "current", licenseNum: "E55678" },
    ]
  },
  {
    id: 6, name: "Emily Tran, PA-C", role: "Midlevel", phone: "(555) 201-0001", email: "e.tran@email.com", status: "active", sites: [1], targetShifts: 13, employmentType: "full_time", maxConsecutive: 0, qualifications: [],
    credentials: [
      { site: "Desert Valley", siteId: 1, type: "State Medical License", expires: "2026-07-15", status: "current", licenseNum: "PA-1001" },
      { site: "Desert Valley", siteId: 1, type: "ACLS Certification", expires: "2026-11-01", status: "current", licenseNum: "ACLS-ET" },
    ]
  },
  {
    id: 7, name: "Jason Moore, NP", role: "Midlevel", phone: "(555) 201-0002", email: "j.moore@email.com", status: "active", sites: [1, 2], targetShifts: 14, employmentType: "full_time", maxConsecutive: 0, qualifications: [],
    credentials: [
      { site: "Desert Valley", siteId: 1, type: "State Medical License", expires: "2026-05-01", status: "expiring", licenseNum: "NP-2002" },
      { site: "Desert Valley", siteId: 1, type: "ACLS Certification", expires: "2026-06-15", status: "current", licenseNum: "ACLS-JM" },
      { site: "Chino Valley", siteId: 2, type: "State Medical License", expires: "2026-10-15", status: "current", licenseNum: "NP-2002" },
      { site: "Chino Valley", siteId: 2, type: "ACLS Certification", expires: "2026-06-15", status: "current", licenseNum: "ACLS-JM" },
    ]
  },
  {
    id: 8, name: "Dr. Lisa Okafor", role: "Physician", phone: "(555) 101-0006", email: "l.okafor@email.com", status: "active", sites: [2, 3], targetShifts: 14, employmentType: "full_time", maxConsecutive: 0, qualifications: [],
    credentials: [
      { site: "Chino Valley", siteId: 2, type: "State Medical License", expires: "2026-08-20", status: "current", licenseNum: "F66789" },
      { site: "Chino Valley", siteId: 2, type: "DEA Registration", expires: "2026-12-01", status: "current", licenseNum: "DEA-LO006" },
      { site: "Chino Valley", siteId: 2, type: "ACLS Certification", expires: "2026-07-01", status: "current", licenseNum: "ACLS-LO" },
      { site: "Montclair", siteId: 3, type: "State Medical License", expires: "2026-08-20", status: "current", licenseNum: "F66789" },
      { site: "Montclair", siteId: 3, type: "DEA Registration", expires: "2026-12-01", status: "current", licenseNum: "DEA-LO006" },
    ]
  },
  {
    id: 9, name: "Carlos Mendez, PA-C", role: "Midlevel", phone: "(555) 201-0003", email: "c.mendez@email.com", status: "active", sites: [2, 3], targetShifts: 12, employmentType: "full_time", maxConsecutive: 0, qualifications: [],
    credentials: [
      { site: "Chino Valley", siteId: 2, type: "State Medical License", expires: "2026-11-01", status: "current", licenseNum: "PA-3003" },
      { site: "Chino Valley", siteId: 2, type: "ACLS Certification", expires: "2027-01-15", status: "current", licenseNum: "ACLS-CM" },
      { site: "Montclair", siteId: 3, type: "State Medical License", expires: "2026-04-01", status: "expiring", licenseNum: "PA-3003" },
    ]
  },
  {
    id: 10, name: "Dr. William Park", role: "Physician", phone: "(555) 101-0007", email: "w.park@email.com", status: "inactive", sites: [1], targetShifts: 0, employmentType: "full_time", maxConsecutive: 0, qualifications: ["ABEM Board Certified"],
    credentials: [{ site: "Desert Valley", siteId: 1, type: "State Medical License", expires: "2025-12-01", status: "expired", licenseNum: "G77890" }]
  },
];

export var TIMEOFF_INIT = [
  { id: 1, providerId: 1, startDate: "2026-03-05", endDate: "2026-03-07", reason: "Family vacation", status: "approved" },
  { id: 2, providerId: 4, startDate: "2026-03-14", endDate: "2026-03-14", reason: "CME conference", status: "approved" },
  { id: 3, providerId: 7, startDate: "2026-03-20", endDate: "2026-03-22", reason: "Personal", status: "pending" },
  { id: 4, providerId: 2, startDate: "2026-03-28", endDate: "2026-03-31", reason: "Vacation", status: "pending" },
];

export var SWAPS_INIT = [
  { id: 1, requestorId: 1, assignmentKey: "2026-03-10_1_1", type: "swap", targetId: 4, targetIds: [4], acceptedBy: null, declinedBy: [], message: "Doctor appointment \u2014 can Dr. Patel cover?", reason: "Doctor appointment", status: "awaiting_response", createdAt: "2026-02-26", targetAssignmentKey: null },
  { id: 2, requestorId: 6, assignmentKey: "2026-03-18_1_3", type: "coverage", targetId: null, targetIds: [], acceptedBy: null, declinedBy: [], message: "", reason: "Family emergency", status: "pending", createdAt: "2026-02-27" },
  { id: 3, requestorId: 4, assignmentKey: "2026-03-12_2_6", type: "give_up", targetId: null, targetIds: [1, 3, 8], acceptedBy: null, declinedBy: [], message: "Hey team, I have a family obligation on the 12th. Would anyone be able to cover my MD Day at Chino Valley? I'd really appreciate it!", reason: "Family obligation", status: "awaiting_response", createdAt: "2026-02-27" },
];

export var AVAILABILITY_INIT = [
  { id: 1, providerId: 1, year: 2026, month: 2, unavailableDays: [5, 6, 7, 14, 21, 28], notes: "CME conference first week, prefer no weekends", submittedAt: "2026-02-20" },
  { id: 2, providerId: 2, year: 2026, month: 2, unavailableDays: [1, 8, 15, 22, 29], notes: "No Sundays please", submittedAt: "2026-02-18" },
  { id: 3, providerId: 4, year: 2026, month: 2, unavailableDays: [12, 13, 14, 26, 27], notes: "", submittedAt: "2026-02-22" },
  { id: 4, providerId: 6, year: 2026, month: 2, unavailableDays: [3, 4, 18, 19, 25, 26], notes: "School events", submittedAt: "2026-02-21" },
  { id: 5, providerId: 7, year: 2026, month: 2, unavailableDays: [20, 21, 22], notes: "Personal", submittedAt: "2026-02-19" },
];

export var RULE_TYPES = [
  { id: "priority", label: "Priority Level", desc: "Control fill order in auto-generator" },
  { id: "no_shift", label: "Shift Restriction", desc: "Never schedule for a specific shift" },
  { id: "fixed_days", label: "Fixed Day Pattern", desc: "Always schedule on specific days of the week" },
  { id: "no_days", label: "Day Restriction", desc: "Never schedule on specific days of the week" },
  { id: "prefer_shift", label: "Preferred Shift", desc: "Soft preference for a specific shift type" },
  { id: "prefer_site", label: "Preferred Sites", desc: "Soft preference for hospitals, in order; other sites only where needed" },
  { id: "max_consecutive", label: "Max Consecutive Days", desc: "Maximum number of consecutive working days allowed" },
  { id: "min_rest_hours", label: "Min Rest Between Shifts", desc: "Minimum hours of rest required between shifts" },
];

export var SCHED_RULES_INIT = [
  { id: 1, providerId: 1, type: "priority", level: "high", note: "Senior physician \u2014 fill target first" },
  { id: 2, providerId: 2, type: "no_shift", hospitalId: 1, shiftName: "MD Night", note: "Cannot do night shifts due to medical condition" },
  { id: 3, providerId: 4, type: "fixed_days", days: [4, 5, 6], note: "Always works Thu/Fri/Sat" },
  { id: 4, providerId: 4, type: "priority", level: "high", note: "Works 3 sites \u2014 prioritize to hit target" },
  { id: 5, providerId: 6, type: "no_days", days: [0, 6], note: "No weekends \u2014 childcare" },
  { id: 6, providerId: 3, type: "prefer_shift", hospitalId: 2, shiftName: "MD Day", note: "Prefers day shifts at Chino Valley" },
  { id: 7, providerId: 8, type: "fixed_days", days: [1, 2, 3], note: "Mon/Tue/Wed pattern" },
];

export var PAY_RATES_INIT = [
  { id: 1, providerId: null, hospitalId: null, shiftId: null, role: "Physician", hourlyRate: 250, label: "Default Physician" },
  { id: 2, providerId: null, hospitalId: null, shiftId: null, role: "Midlevel", hourlyRate: 125, label: "Default Midlevel" },
  { id: 3, providerId: null, hospitalId: 1, shiftId: 2, role: null, hourlyRate: 275, label: "Desert Valley MD Night" },
  { id: 4, providerId: null, hospitalId: 2, shiftId: 8, role: null, hourlyRate: 280, label: "Chino Valley MD Night" },
  { id: 5, providerId: 1, hospitalId: null, shiftId: null, role: null, hourlyRate: 270, label: "Dr. Chen \u2014 All Sites" },
  { id: 6, providerId: 4, hospitalId: 1, shiftId: null, role: null, hourlyRate: 265, label: "Dr. Patel \u2014 Desert Valley" },
];


// ---- HELPERS ----
export function shiftHours(startTime, endTime) {
  var sp = startTime.split(":"); var ep = endTime.split(":");
  var s = +sp[0] * 60 + +sp[1]; var e = +ep[0] * 60 + +ep[1];
  if (e <= s) e += 24 * 60;
  return Math.round((e - s) / 60 * 100) / 100;
}
export function resolveRate(providerId, hospitalId, shiftId, providerRole, rates) {
  // 6-tier fallback: exact -> provider+hosp -> provider -> hosp+shift -> hosp -> role default
  var exact = rates.find(function (r) { return r.providerId === providerId && r.hospitalId === hospitalId && r.shiftId === shiftId; });
  if (exact) return exact.hourlyRate;
  var provHosp = rates.find(function (r) { return r.providerId === providerId && r.hospitalId === hospitalId && !r.shiftId; });
  if (provHosp) return provHosp.hourlyRate;
  var provOnly = rates.find(function (r) { return r.providerId === providerId && !r.hospitalId && !r.shiftId; });
  if (provOnly) return provOnly.hourlyRate;
  var hospShift = rates.find(function (r) { return !r.providerId && r.hospitalId === hospitalId && r.shiftId === shiftId; });
  if (hospShift) return hospShift.hourlyRate;
  var hospOnly = rates.find(function (r) { return !r.providerId && r.hospitalId === hospitalId && !r.shiftId; });
  if (hospOnly) return hospOnly.hourlyRate;
  var roleDef = rates.find(function (r) { return !r.providerId && !r.hospitalId && !r.shiftId && r.role === providerRole; });
  return roleDef ? roleDef.hourlyRate : 0;
}
export function getToday() { return new Date().toISOString().slice(0, 10); }
// TODAY is mutable — AppInner resets it on each render via refreshTODAY()
export var TODAY = getToday();
export function refreshTODAY() { TODAY = getToday(); }
export var MN = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export var DN = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
// Public address of the app, used in emails (invites, password resets) so links
// never point at localhost or a preview host when sent from a dev build.
export var APP_PUBLIC_URL = "https://app.rosterdr.com";
export function fmtTime(t) { var p = t.split(":"); var h = +p[0]; var m = +p[1]; var hr = h === 0 ? 12 : h > 12 ? h - 12 : h; return hr + (m > 0 ? ":" + String(m).padStart(2, "0") : "") + (h >= 12 ? "p" : "a"); }
export function daysIn(y, m) { return new Date(y, m + 1, 0).getDate(); }
export function firstDow(y, m) { return new Date(y, m, 1).getDay(); }
export function dk(y, m, d) { return y + "-" + String(m + 1).padStart(2, "0") + "-" + String(d).padStart(2, "0"); }
export function mk(y, m) { return y + "-" + String(m + 1).padStart(2, "0"); }
export function ak(ds, hi, si) { return ds + "_" + hi + "_" + si; }
export function shortN(n) { var p = n.replace("Dr. ", "").split(",")[0].split(" "); return p.length >= 2 ? p[0][0] + ". " + p[p.length - 1] : p[0]; }
export var PROV_COLORS = ["#2563eb","#dc2626","#059669","#7c3aed","#d97706","#0891b2","#be185d","#4f46e5","#b91c1c","#0d9488","#9333ea","#c2410c","#1d4ed8","#15803d","#a21caf","#ea580c","#0369a1","#9f1239","#4338ca","#166534","#7e22ce","#b45309","#1e40af","#047857","#6d28d9","#92400e","#0e7490","#881337","#3730a3","#065f46"];
export function provColor(id) { return PROV_COLORS[(+id || 0) % PROV_COLORS.length]; }
export function fmtDateNice(ds) { var p = ds.split("-"); return MN[+p[1] - 1] + " " + parseInt(p[2]); }
export function isOff(pid, ds, tos) { return tos.some(function (t) { return t.providerId === pid && t.status !== "denied" && ds >= t.startDate && ds <= t.endDate; }); }
// Normalize unavailableDays — old format: [1,5,12] → new format: {1:"all",5:"all",12:"all"}
export function normalizeUnavail(ud) {
  if (!ud) return {};
  if (Array.isArray(ud)) { var obj = {}; ud.forEach(function (d) { obj[d] = "all"; }); return obj; }
  if (typeof ud === "object") return ud;
  return {};
}
// Check if provider marked a day as unavailable. Auto-generate treats this as a hard
// constraint (available providers are always chosen first; an unavailable provider is a
// last resort only when no available one can fill the slot, and it's flagged in Issues).
// Returns false, "am", "pm", or "all"
export function isUnavail(pid, day, year, month, avails) { var rec = avails.find(function (a) { return a.providerId === pid && a.year === year && a.month === month; }); if (!rec) return false; var ud = normalizeUnavail(rec.unavailableDays); return ud[day] || false; }
// Check if a shift is an AM (morning/day) shift — starts before 14:00
export function isShiftAM(shift) { return parseInt((shift.start || "06:00").split(":")[0], 10) < 14; }
// Check if provider is unavailable FOR A SPECIFIC SHIFT (AM/PM aware)
export function isUnavailForShift(pid, day, year, month, avails, shift) {
  var unavail = isUnavail(pid, day, year, month, avails);
  if (!unavail) return false;
  if (unavail === "all") return true;
  var am = isShiftAM(shift);
  if (unavail === "am" && am) return true;
  if (unavail === "pm" && !am) return true;
  return false;
}
// Dynamically compute credential status from expiration date (never trust stored status)
export function credStatus(expires) { var days = Math.ceil((new Date(expires) - new Date(TODAY)) / 86400000); return days < 0 ? "expired" : days < 90 ? "expiring" : "current"; }
export function credDaysLeft(expires) { return Math.ceil((new Date(expires) - new Date(TODAY)) / 86400000); }
// Check if a provider meets ALL credential requirements for a specific shift at a hospital
// Check if provider meets a hospital's credential requirements (hospital-level, role-specific)
export function checkCredCompliance(provider, hospital) {
  var allReqs = hospital.credentialTypes || [];
  // Filter to requirements that apply to this provider's role
  var provRole = provider.role; // "Physician" or "Midlevel"
  var provSubRole = provider.subRole || ""; // "MD", "DO", "NP", "PA"
  var reqs = allReqs.filter(function (req) {
    if (typeof req === "string") return true; // legacy: plain string applies to all
    var r = req.role || "All";
    if (r === "All") return true;
    if (r === "Physician" && provRole === "Physician") return true;
    if (r === "Midlevel" && provRole === "Midlevel") return true;
    // Sub-role exact match (MD, DO, NP, PA)
    if (r === provSubRole) return true;
    return false;
  });
  var provCreds = provider.credentials || [];
  var missing = []; var expiring = []; var met = [];
  reqs.forEach(function (req) {
    var reqType = typeof req === "string" ? req : req.type;
    var cred = provCreds.find(function (c) { return c.type === reqType; });
    if (!cred) { missing.push(reqType); }
    else {
      var st = credStatus(cred.expires);
      if (st === "expired") { missing.push(reqType + " (expired)"); }
      else if (st === "expiring") { expiring.push({ type: reqType, expires: cred.expires }); met.push({ type: reqType, status: "expiring" }); }
      else { met.push({ type: reqType, status: "current" }); }
    }
  });
  return { ok: missing.length === 0, missing: missing, expiring: expiring, met: met, total: reqs.length };
}

// Minimum rest between the end of one shift and the start of the next (hours), unless a
// provider has a min_rest_hours rule. Used by Schedule Builder, the portal's open-shift list,
// and the give-up request partner list so nobody is offered a shift they cannot work.
export var MIN_TURNAROUND_HOURS = 8;
export function minRestHoursFor(pid, schedRules, monthKey) {
  var r = (schedRules || []).find(function (x) { return x.providerId === pid && x.type === "min_rest_hours" && (!x.monthKey || x.monthKey === monthKey); });
  return r && r.value ? +r.value : 0;
}
// Why a provider cannot take `shift` on `dateStr` given the assignments map, or "" when they can:
// already working that day, or too little rest after the previous day's overnight shift / before
// the next day's shift. Time-off is checked separately with isOff.
export function shiftConflict(pid, dateStr, shift, assignments, hospitals, minRestHours) {
  var minRest = minRestHours > 0 ? minRestHours : MIN_TURNAROUND_HOURS;
  var toMin = function (t) { var p = String(t || "0:0").split(":"); return (+p[0]) * 60 + (+p[1] || 0); };
  var shiftDay = function (ds, delta) { var d = new Date(ds + "T12:00:00"); d.setDate(d.getDate() + delta); return d.toISOString().slice(0, 10); };
  var startMin = toMin(shift.start), endMin = toMin(shift.end), overnight = endMin <= startMin;
  var prevDs = shiftDay(dateStr, -1), nextDs = shiftDay(dateStr, 1);
  var reason = "";
  Object.keys(assignments || {}).forEach(function (k) {
    if (reason || assignments[k] !== pid) return;
    var parts = k.split("_"); var ds = parts[0];
    if (ds !== dateStr && ds !== prevDs && ds !== nextDs) return;
    var h = (hospitals || []).find(function (x) { return x.id === +parts[1]; });
    var s = h ? (h.shifts || []).find(function (x) { return x.id === +parts[2]; }) : null;
    var label = (s ? s.name : "a shift") + (h ? " at " + h.short : "");
    if (ds === dateStr) { reason = "Already working " + label + " that day"; return; }
    if (!s) return;
    var sStart = toMin(s.start), sEnd = toMin(s.end), sOvernight = sEnd <= sStart;
    if (ds === prevDs && sOvernight) {
      var gap = (startMin - sEnd) / 60;
      if (gap < minRest) reason = "Working " + label + " the night before" + (gap > 0 ? " (" + Math.round(gap * 10) / 10 + " h rest)" : "");
    } else if (ds === nextDs && overnight) {
      var gap2 = (sStart - endMin) / 60;
      if (gap2 < minRest) reason = "Working " + label + " the next morning" + (gap2 > 0 ? " (" + Math.round(gap2 * 10) / 10 + " h rest)" : "");
    }
  });
  return reason;
}
export function getEligible(shift, hId, provs, hospitals) {
  var h = hospitals ? hospitals.find(function (x) { return x.id === +hId || x.id === hId; }) : null;
  return provs.filter(function (p) {
    if (p.status !== "active" || (p.sites || []).map(Number).indexOf(+hId) < 0) return false;
    if (shift.role === "MD" && p.role !== "Physician") return false;
    if (shift.role === "Midlevel" && p.role !== "Midlevel") return false;
    if (shift.role === "MD/Midlevel" && p.role !== "Physician" && p.role !== "Midlevel") return false;
    // Check hospital-level credential requirements
    if (h) { var comp = checkCredCompliance(p, h); if (!comp.ok) return false; }
    return true;
  });
}
export function downloadCSV(fn, str) { var b = new Blob([str], { type: "text/csv" }); var u = URL.createObjectURL(b); var a = document.createElement("a"); a.href = u; a.download = fn; a.click(); URL.revokeObjectURL(u); }
export function downloadBlob(fn, str, mime) { var b = new Blob([str], { type: mime }); var u = URL.createObjectURL(b); var a = document.createElement("a"); a.href = u; a.download = fn; a.click(); URL.revokeObjectURL(u); }
export function icsDate(dateStr, timeStr) {
  // dateStr: "2026-03-15", timeStr: "06:00" -> "20260315T060000"
  return dateStr.replace(/-/g, "") + "T" + timeStr.replace(":", "") + "00";
}
export function nextDay(dateStr) {
  var d = new Date(dateStr + "T12:00:00"); d.setDate(d.getDate() + 1);
  return d.toISOString().slice(0, 10);
}
export function generateICS(events, calName) {
  var tz = "America/Los_Angeles";
  var lines = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//RosterDr//Schedule//EN",
    "CALSCALE:GREGORIAN",
    "X-WR-CALNAME:" + calName,
    "X-WR-TIMEZONE:" + tz,
    "BEGIN:VTIMEZONE",
    "TZID:" + tz,
    "BEGIN:DAYLIGHT",
    "TZOFFSETFROM:-0800",
    "TZOFFSETTO:-0700",
    "TZNAME:PDT",
    "DTSTART:19700308T020000",
    "RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU",
    "END:DAYLIGHT",
    "BEGIN:STANDARD",
    "TZOFFSETFROM:-0700",
    "TZOFFSETTO:-0800",
    "TZNAME:PST",
    "DTSTART:19701101T020000",
    "RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU",
    "END:STANDARD",
    "END:VTIMEZONE"
  ];
  events.forEach(function (ev) {
    var isOvernight = ev.endTime <= ev.startTime;
    var endDate = isOvernight ? nextDay(ev.date) : ev.date;
    lines.push("BEGIN:VEVENT");
    lines.push("UID:" + ev.uid + "@rosterdr");
    lines.push("DTSTART;TZID=" + tz + ":" + icsDate(ev.date, ev.startTime));
    lines.push("DTEND;TZID=" + tz + ":" + icsDate(endDate, ev.endTime));
    lines.push("SUMMARY:" + ev.summary);
    if (ev.location) lines.push("LOCATION:" + ev.location);
    if (ev.description) lines.push("DESCRIPTION:" + ev.description.replace(/\n/g, "\\n"));
    lines.push("END:VEVENT");
  });
  lines.push("END:VCALENDAR");
  return lines.join("\r\n");
}
export function parseAK(key) { var p = key.split("_"); return { date: p[0], hospId: +p[1], shiftId: +p[2] }; }
// AI helper - calls Cloud Function via Firebase
export function callAI(companyId, prompt) {
  return aiPrompt({ prompt: prompt, companyId: companyId }).then(function (result) { return result.data.text || ""; });
}

// ---- DATE FORMATTING ----
export function formatDate(dateStr) {
  if (!dateStr) return "\u2014";
  var parts = dateStr.split("-");
  if (parts.length !== 3) return dateStr;
  var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return monthNames[+parts[1] - 1] + " " + parseInt(parts[2]) + ", " + parts[0];
}

// ---- UI COMPONENTS ----
export var thS = { textAlign: "left", padding: "10px 14px", color: "#64748b", fontWeight: 600, fontSize: 11, textTransform: "uppercase", letterSpacing: "0.05em" };
export var inpS = { padding: "7px 10px", borderRadius: 6, border: "1px solid #d1d5db", fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box" };
export var HC = { 1: "#2563eb", 2: "#7c3aed", 3: "#c2410c" };
export var HB = { 1: "dv", 2: "cv", 3: "mc" };

export function Badge({ children, variant }) {
  var map = {
    // Red variants (danger/critical)
    expired: { bg: "#fef2f2", c: "#dc2626", b: "#fecaca" }, denied: { bg: "#fef2f2", c: "#dc2626", b: "#fecaca" },
    critical: { bg: "#fef2f2", c: "#dc2626", b: "#fecaca" }, required: { bg: "#fef2f2", c: "#dc2626", b: "#fecaca" },
    disputed: { bg: "#fef2f2", c: "#dc2626", b: "#fecaca" }, action_needed: { bg: "#dc2626", c: "#fff", b: "#dc2626" },
    // Orange/Yellow variants (warning)
    pending: { bg: "#fffbeb", c: "#d97706", b: "#fde68a" }, expiring: { bg: "#fffbeb", c: "#d97706", b: "#fde68a" },
    warning: { bg: "#fffbeb", c: "#d97706", b: "#fde68a" }, review: { bg: "#fffbeb", c: "#d97706", b: "#fde68a" },
    awaiting_response: { bg: "#fffbeb", c: "#d97706", b: "#fde68a" },
    // Green variants (success)
    active: { bg: "#ecfdf5", c: "#059669", b: "#a7f3d0" }, approved: { bg: "#ecfdf5", c: "#059669", b: "#a7f3d0" },
    current: { bg: "#ecfdf5", c: "#059669", b: "#a7f3d0" }, published: { bg: "#ecfdf5", c: "#059669", b: "#a7f3d0" },
    completed: { bg: "#ecfdf5", c: "#059669", b: "#a7f3d0" },
    // Blue variants (info)
    physician: { bg: "#eff6ff", c: "#2563eb", b: "#bfdbfe" }, default: { bg: "#eff6ff", c: "#2563eb", b: "#bfdbfe" },
    info: { bg: "#eff6ff", c: "#2563eb", b: "#bfdbfe" }, provider_signed: { bg: "#eff6ff", c: "#2563eb", b: "#bfdbfe" },
    swap: { bg: "#eff6ff", c: "#2563eb", b: "#bfdbfe" },
    // Purple variants
    midlevel: { bg: "#faf5ff", c: "#7c3aed", b: "#ddd6fe" }, coverage: { bg: "#faf5ff", c: "#7c3aed", b: "#ddd6fe" },
    // Gray variants
    inactive: { bg: "#f1f5f9", c: "#64748b", b: "#e2e8f0" }, archived: { bg: "#f1f5f9", c: "#64748b", b: "#e2e8f0" },
    dismissed: { bg: "#f1f5f9", c: "#64748b", b: "#e2e8f0" }, draft: { bg: "#f1f5f9", c: "#64748b", b: "#e2e8f0" },
    empty: { bg: "#f1f5f9", c: "#64748b", b: "#e2e8f0" }, filled: { bg: "#f1f5f9", c: "#64748b", b: "#e2e8f0" },
    // Hospital-specific (keep distinct)
    dv: { bg: "#eff6ff", c: "#1e40af", b: "#bfdbfe" }, cv: { bg: "#faf5ff", c: "#7c3aed", b: "#ddd6fe" }, mc: { bg: "#fff7ed", c: "#c2410c", b: "#fed7aa" },
    give_up: { bg: "#fff7ed", c: "#c2410c", b: "#fed7aa" },
  };
  var s = map[variant] || map.default;
  return <span style={{ background: s.bg, color: s.c, border: "1px solid " + s.b, padding: "2px 10px", borderRadius: 999, fontSize: 11, fontWeight: 600, letterSpacing: "0.02em", textTransform: "uppercase", whiteSpace: "nowrap", display: "inline-block" }}>{children}</span>;
}

export function StatCard({ icon, label, value, sub, accent }) {
  return <div style={{ background: "#fff", borderRadius: 12, padding: "14px 18px", border: "1px solid #e8ecf1", display: "flex", alignItems: "center", gap: 12, flex: 1, minWidth: 140 }}>
    <div style={{ width: 36, height: 36, borderRadius: 8, background: accent || "#f0f4ff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: 16 }}>{icon}</div>
    <div><div style={{ fontSize: 20, fontWeight: 700, color: "#0f172a", lineHeight: 1.1 }}>{value}</div><div style={{ fontSize: 11, color: "#64748b", marginTop: 1 }}>{label}</div>{sub && <div style={{ fontSize: 10, color: "#94a3b8" }}>{sub}</div>}</div>
  </div>;
}
// Format a Firestore Timestamp (or Date/ISO string) as "Oct 18, 2026"
export function fmtTimestamp(ts) { if (!ts) return ""; var d = ts.toDate ? ts.toDate() : new Date(ts); if (isNaN(d.getTime())) return ""; return d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" }); }

// ---- SITE SCHEDULE (shared by the admin print and the hospital-contact emails) ----
// Pure JS, no imports: this exact block is also pasted into functions/index.js.
var SS_MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
var SS_DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
function ssEsc(v) { return String(v == null ? "" : v).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"); }
function ssTime(t) { if (!t) return ""; var p = String(t).split(":"); var h = +p[0], m = +p[1] || 0; var hr = h === 0 ? 12 : h > 12 ? h - 12 : h; return hr + (m > 0 ? ":" + String(m).padStart(2, "0") : "") + (h >= 12 ? "p" : "a"); }
function ssRoleTag(p) { if (!p) return ""; if (p.role === "Physician") return "MD"; if (p.subRole && /^(NP|PA)$/i.test(p.subRole)) return p.subRole.toUpperCase(); if (p.role === "Midlevel") return "APP"; return ""; }
function ssDisplayName(p) { if (!p) return ""; var tag = ssRoleTag(p); return p.name + (tag ? ", " + tag : ""); }
// opts: { hospital, year, month (0-based), assignments {key: providerId}, providers [], shiftOverrides {key: {start,end}}, customShifts [], status, changes [strings] }
// Returns { html: table + optional change list (inline styles, email-safe), text: plain-text version, open: number of required slots unfilled }
export function siteScheduleSection(opts) {
  var h = opts.hospital, y = opts.year, m = opts.month;
  var assignments = opts.assignments || {}, overrides = opts.shiftOverrides || {}, customShifts = opts.customShifts || [];
  var provById = {}; (opts.providers || []).forEach(function (p) { provById[String(p.id)] = p; });
  // Columns: physician (and shared) shifts first, then Fast Track / midlevel-only shifts; each group in start-time order.
  var shifts = (h.shifts || []).slice().sort(function (x, z) { var gx = x.role === "Midlevel" ? 1 : 0, gz = z.role === "Midlevel" ? 1 : 0; if (gx !== gz) return gx - gz; var sx = String(x.start || ""), sz = String(z.start || ""); if (sx !== sz) return sx < sz ? -1 : 1; return (+x.id || 0) - (+z.id || 0); });
  var rules = {}; (h.staffingRules || []).forEach(function (r) { rules[r.shift] = r; });
  var dim = new Date(y, m + 1, 0).getDate();
  var monthName = SS_MONTHS[m] + " " + y;
  var hasCustom = customShifts.some(function (cs) { return cs.hospId === h.id && String(cs.date || "").indexOf(y + "-" + String(m + 1).padStart(2, "0")) === 0; });
  var th = "padding:6px 8px;background:#f1f5f9;color:#475569;font-size:11px;text-transform:uppercase;letter-spacing:.04em;border:1px solid #cbd5e1;text-align:left;";
  var td = "padding:6px 8px;border:1px solid #cbd5e1;font-size:12px;vertical-align:top;";
  var html = "<table style=\"width:100%;border-collapse:collapse;font-family:-apple-system,'DM Sans','Segoe UI',sans-serif;color:#0f172a;\"><thead><tr><th style=\"" + th + "width:110px;\">Date</th>";
  shifts.forEach(function (s) { html += "<th style=\"" + th + "\">" + ssEsc(s.name) + "<br><span style=\"font-weight:400;text-transform:none;letter-spacing:0;color:#64748b;\">" + ssEsc(ssTime(s.start) + "–" + ssTime(s.end)) + "</span></th>"; });
  if (hasCustom) html += "<th style=\"" + th + "\">Extra</th>";
  html += "</tr></thead><tbody>";
  var text = []; var open = 0;
  for (var d = 1; d <= dim; d++) {
    var ds = y + "-" + String(m + 1).padStart(2, "0") + "-" + String(d).padStart(2, "0");
    var dow = new Date(y, m, d).getDay(); var weekend = dow === 0 || dow === 6;
    var rowBg = weekend ? "background:#f8fafc;" : "";
    html += "<tr><td style=\"" + td + rowBg + "white-space:nowrap;font-weight:600;\">" + SS_DAYS[dow] + " " + SS_MONTHS[m].slice(0, 3) + " " + d + "</td>";
    var lineParts = [];
    shifts.forEach(function (s) {
      var key = ds + "_" + h.id + "_" + s.id; var pid = assignments[key]; var p = pid != null ? provById[String(pid)] : null;
      var ov = overrides[key]; var timeNote = ov && (ov.start || ov.end) ? " <span style=\"color:#d97706;font-size:11px;\">" + ssEsc(ssTime(ov.start || s.start) + "–" + ssTime(ov.end || s.end)) + "</span>" : "";
      var rule = rules[s.name]; var required = rule && rule.required;
      if (p) { html += "<td style=\"" + td + rowBg + "\">" + ssEsc(ssDisplayName(p)) + timeNote + "</td>"; lineParts.push(s.name + ": " + ssDisplayName(p) + (ov && (ov.start || ov.end) ? " (" + ssTime(ov.start || s.start) + "-" + ssTime(ov.end || s.end) + ")" : "")); }
      else if (pid != null) { html += "<td style=\"" + td + rowBg + "color:#64748b;\">Provider " + ssEsc(pid) + "</td>"; lineParts.push(s.name + ": provider " + pid); }
      else if (required) { open++; html += "<td style=\"" + td + rowBg + "color:#dc2626;font-weight:700;\">OPEN</td>"; lineParts.push(s.name + ": OPEN"); }
      else { html += "<td style=\"" + td + rowBg + "color:#cbd5e1;\">—</td>"; }
    });
    if (hasCustom) {
      var extras = customShifts.filter(function (cs) { return cs.hospId === h.id && cs.date === ds; });
      html += "<td style=\"" + td + rowBg + "\">" + extras.map(function (cs) { var cp = cs.providerId != null ? provById[String(cs.providerId)] : null; var label = ssEsc(cs.name || "Extra") + " " + ssEsc(ssTime(cs.start) + "–" + ssTime(cs.end)) + ": " + (cp ? ssEsc(ssDisplayName(cp)) : "<span style=\"color:#dc2626;font-weight:700;\">OPEN</span>"); lineParts.push((cs.name || "Extra") + " " + ssTime(cs.start) + "-" + ssTime(cs.end) + ": " + (cp ? ssDisplayName(cp) : "OPEN")); return label; }).join("<br>") + "</td>";
    }
    html += "</tr>";
    text.push(SS_DAYS[dow] + " " + SS_MONTHS[m].slice(0, 3) + " " + d + " — " + (lineParts.length ? lineParts.join("; ") : "no coverage listed"));
  }
  html += "</tbody></table>";
  var changesHtml = "";
  if (opts.changes && opts.changes.length) {
    changesHtml = "<div style=\"margin:0 0 14px;padding:10px 14px;background:#fffbeb;border:1px solid #fde68a;border-radius:8px;font-family:-apple-system,'DM Sans','Segoe UI',sans-serif;\"><div style=\"font-weight:700;font-size:13px;color:#92400e;margin-bottom:4px;\">What changed</div><ul style=\"margin:0;padding-left:18px;font-size:12px;color:#334155;line-height:1.5;\">" + opts.changes.map(function (c) { return "<li>" + ssEsc(c) + "</li>"; }).join("") + "</ul></div>";
    text.unshift("WHAT CHANGED:\n" + opts.changes.map(function (c) { return "- " + c; }).join("\n") + "\n");
  }
  return { html: changesHtml + html, text: text.join("\n"), open: open, monthName: monthName, hasCustom: hasCustom };
}
// Full printable document for one or more hospitals (one site per page).
export function buildSiteSchedulePrintHtml(sites, common) {
  var pages = sites.map(function (site) {
    var sec = siteScheduleSection(Object.assign({}, common, { hospital: site }));
    var draft = common.status !== "published";
    return "<section style=\"break-after:page;page-break-after:always;\"><h1 style=\"font-size:20px;margin:0;\">" + ssEsc(site.name) + " — " + ssEsc(sec.monthName) + (draft ? " <span style=\"color:#dc2626;font-size:14px;\">(" + ssEsc(common.status === "review" ? "IN REVIEW" : "DRAFT") + " — not yet published)</span>" : "") + "</h1><p style=\"color:#64748b;margin:2px 0 12px;font-size:12px;\">" + (common.companyName ? ssEsc(common.companyName) + " · " : "") + "printed " + ssEsc(new Date().toLocaleDateString()) + " from RosterDr" + (sec.open ? " · <b style=\"color:#dc2626;\">" + sec.open + " required slot" + (sec.open !== 1 ? "s" : "") + " still open</b>" : "") + "</p>" + sec.html + "</section>";
  }).join("");
  return "<!DOCTYPE html><html><head><meta charset='utf-8'><title>" + ssEsc(sites.length === 1 ? sites[0].name : "Site schedules") + " — " + ssEsc(SS_MONTHS[common.month] + " " + common.year) + "</title><style>@page{size:landscape;margin:10mm}body{margin:0;padding:20px}section:last-child{break-after:auto;page-break-after:auto}thead{display:table-header-group}tr{break-inside:avoid}@media print{body{padding:0}table td,table th{padding:2px 6px !important;font-size:10.5px !important;line-height:1.25}}</style></head><body>" + pages + "</body></html>";
}
